<div class=" modal-header bg-light d-flex justify-content-center ">
    <h4 class="modal-title strong">Place bid</h4>
</div>
<div class="modal-body bg-light">
    <div class="d-flex align-items-center flex-column">
        <h5 class="strong mb-2">{{a?.newName?a?.newName:a?.productName}}</h5>
        <div class="small text-secondary">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
        <div class="small">{{a?.laycanStartDate | date:"dd/MM/yyyy"}} - {{a?.laycanEndDate |
            date:"dd/MM/yyyy"}}</div>
        <!-- <div class="strong small">{{a?.loadPortLaycanStartDate | date:"dd/MM/yyyy"}} - {{a?.loadPortLaycanEndDate | date:"dd/MM/yyyy"}}</div> -->
    </div>
    <div class="form-group">
        <div class="small">
            <h3 class="strong h6">{{ 'tenders.Quantity(DMT)' | cxTranslate }}({{a.displayQuantityUnitDesc}})</h3>
            <div class="h5 strong" *ngIf="a.isQuantityUnrestricted== false">{{a?.quantity | number}}</div>
            <input type="number" min="0" max="999999" [(ngModel)]="quantityshw" class="form-control form-control-lg"
                *ngIf="a.quantity && a.isQuantityUnrestricted== true">

        </div>
    </div>
    <div class="form-group" *ngIf=" a.isDischargePortUnrestricted== true">
        <h6 class="strong">{{ 'tenders.DischargePort' | cxTranslate }}</h6>
        <input type="text" [(ngModel)]="dischargePortshw" class="form-control form-control-lg">
    </div>
    <div class="form-group">
        <!-- <div class="small text-secondary ">{{'tenders.Pricingbasis'|cxTranslate}}</div>
        <div class="small" *ngFor="let pricingBasis of a.pricingBasis">{{pricingBasis?pricingBasis.description:'--'}} </div>
        </div> -->
    
        <div class="form-group">
            
                <div *ngIf="a.baseKOP == 'BA CU'" class="small text-secondary">{{'tenders.QuotationPeriodCU'|
                    cxTranslate}} </div>
                <div *ngIf="a.baseKOP == 'BA ZN'" class="small text-secondary">{{'tenders.QuotationPeriodZN'|
                    cxTranslate}}</div>
                <div *ngIf="a.baseKOP != 'BA CU' && a.baseKOP != 'BA ZN'" class="small text-secondary">
                    {{'tenders.QuotationPeriod'| cxTranslate}}</div>
                    <div *ngIf="a.isQuotationPeriodUnrestricted == false && a.pricingOptionsEnum[0].isQPMultipleChoicesSelected == false" class="small">{{formatQPDates(a)}}
                    </div>
                    <select class="custom-select" (change)="qpChangeAction($event,i,a)" *ngIf=" a.pricingOptionsEnum[0].isQPMultipleChoicesSelected == true" [(ngModel)]="defaultValue">
                        <option value="{{qp.description}}" id="{{qp.uniqueRowNumber}}" *ngFor="let qp of  a.pricingOptionsEnum[0].qpMultipleChoices;" >{{qp.description}}  </option>   
                    </select>
                    
            
        </div>
        <div class="mt-2">
            <div class="small text-secondary ">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
            <div class=" small" >{{productInfo.termsAndConditions?productInfo.termsAndConditions.description:'--'}} </div>
    <div>
        <div *ngFor="let child of a?.childList">
            <div class="form-group">
                <h3 class="strong h6 mt-4">{{child.productName}} TC (per {{a.displayTCPriceConfig.displayTCPriceUnitDesc}})</h3>
                <span class=" currency-icon position-absolute">USD &nbsp;</span>
                <input type="text" [(ngModel)]="child.priceshw" (change)="divide();" 
                appAllowNegativeDecimalNumber [beforeDecimal]="a.displayTCPriceConfig.displayTCPriceBeforeDecimals" [afterDecimal]="a.displayTCPriceConfig.displayTCPriceAfterDecimals"         
                    class="form-control form-control-lg  pl-5" preventCutCopyPaste
                    required #name="ngModel" />
            </div>
            <div *ngIf="a.displayRCPriceConfig.displayRCPrice == true" class="form-group">
                <h3 class="strong h6">{{child.productName}} RC (per {{a.displayRCPriceConfig.displayRCPriceUnitDesc}} of payable Copper)</h3>
                <span class=" currency-icon position-absolute">USD &nbsp;</span>
                <input  [(ngModel)]="child.indexPriceshw" disabled class="form-control form-control-lg  pl-5" required
                    #name="ngModel" />
            </div>
        </div>
        <div *ngIf="a?.childList==undefined">
            <div class="form-group">
                <h3 class="strong h6 mt-4">Enter your TC (per {{a.displayTCPriceConfig.displayTCPriceUnitDesc}})</h3>
                <span class=" currency-icon position-absolute">USD &nbsp;</span>
                <input type="text" [(ngModel)]="priceshw" (change)="divide()" 
                appAllowNegativeDecimalNumber  [beforeDecimal]="a.displayTCPriceConfig.displayTCPriceBeforeDecimals" [afterDecimal]="a.displayTCPriceConfig.displayTCPriceAfterDecimals"        
                    class="form-control form-control-lg  pl-5" preventCutCopyPaste
                    required #name="ngModel" />
                    <p *ngIf="PriceEmpty==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.enterprice'| cxTranslate}}</p>    
            </div>
            <div *ngIf="a.displayRCPriceConfig.displayRCPrice == true" class="form-group">
                <h3 class="strong h6">Enter your RC (per {{a.displayRCPriceConfig.displayRCPriceUnitDesc}} of payable Copper)</h3>
                <span class=" currency-icon position-absolute">USD &nbsp;</span>
                <input  [(ngModel)]="indexPriceshw" disabled class="form-control form-control-lg  pl-5" required
                    #name="ngModel" />
            </div>
        </div>
        
    </div>
    <div>
    </div>
</div>

<div class="modal-footer bg-light">
    <div class="w-100">
        <button class="btn btn-block btn-primary btn-lg" type="submit"
            (click)="Openmodal()">{{'tenders.Next'|cxTranslate}}</button>
        <button class="btn btn-block btn-lg btn-light" type="button" (click)="close()">{{ 'home.productHeader.Close' |
            cxTranslate }}</button>
    </div>
</div>